import * as React from 'react';
export const IcCallForward = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18.16 14.32a2 2 0 00-2.82 0l-.71.71a1.001 1.001 0 01-1.42 0L9 10.79a1 1 0 010-1.42l.71-.71a2 2 0 000-2.82L9 5.13a2 2 0 00-2.83 0l-1 1a1.89 1.89 0 00-.57 1.13c-.18 1.4-.08 4.74 3.67 8.47 3.75 3.73 7.07 3.85 8.48 3.68a1.89 1.89 0 001.13-.57l1-1a2.002 2.002 0 000-2.83l-.72-.69zm2.55-8l-2-2a1.005 1.005 0 00-1.42 1.42L18.59 7l-1.3 1.29a.998.998 0 000 1.42.999.999 0 001.42 0l2-2a1.001 1.001 0 000-1.42v.03zm-7.42 3.39a.999.999 0 001.42 0l2-2a1.001 1.001 0 000-1.42l-2-2a1.005 1.005 0 00-1.42 1.42L14.59 7l-1.3 1.29a.998.998 0 000 1.42z'
      fill='currentColor'
    />
  </svg>
);
